import { render, staticRenderFns } from "./approveDetail.vue?vue&type=template&id=7dd965e3&scoped=true"
import script from "./approveDetail.vue?vue&type=script&lang=js"
export * from "./approveDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd965e3",
  null
  
)

export default component.exports